// import style from './Homespeeches.module.css'
// import rightImage from '../../Assets/HomePage Speeches/v1_123.png'
// import lefttImage from '../../Assets/HomePage Speeches/v1_127.png'
// import lefttImage2 from '../../Assets/HomePage Speeches/v1_155.png'
// import lefttImage3 from '../../Assets/HomePage Speeches/v1_133.png'
// import playIcon from '../../Assets/products/602kss3h_expires_30_days.png'
// import { useEffect, useState } from 'react'
// import { data } from 'react-router-dom'
// import axios from 'axios'

// export default function Homespeeches() {

//     const[data,SetData] = useState([])

//     useEffect(() => {
//         const response =  axios.get('https://../fa/?function=getLatestSpeeches')
//         .then((data) => console.log(data.data))
        
        
//     },[])

//     return(<>
//         <div className={style.speeches}>
//         <div className={style.container}>
//             <div className={style.right}>  
//                 <div className={style.content}> 
//                     <img className={style.cover} src={rightImage} alt='homespeeches'/>
//                     <div className={style.playicon}>
//                         <img src={playIcon} alt='homespeeches'/>
//                     </div>
//                 </div>
//                 <div className={style.text}> 
//                     <h3>فارسی صحبت کردن شهید سیدحسن نصرالله </h3>
//                     <p className={style.para}>سید حسن  (۱۳۳۹-۱۴۰۳ش) ملقب به سید مقاومت روحانی و سیاستمدار شیعه اهل لبنان، سومین دبیرکل  لبنان و از بنیانگذاران آن بود.
//                          در دوران دبیرکلی وی‌ (از سال ۱۹۹۲م-۲۰۲۴م) به قدرتی منطقه‌ای تبدیل شد. آزادسازی   در ۲۰۰۰م از اشغال    
//                         لبنانی و بازپس‌گیری اجساد شهدای مقاومت از دست اسرائیل در ۲۰۰۴م و پیروزی در جنگ ۳۳ روزه در ۲۰۰۶م در زمان دبیرکلی  روی داد. او به دلیل مقاومت
//                         و پیروزی‌های چندباره در برابر  محبوب‌ترین و قدرتمندترین رهبرِ جهان عرب شناخته می‌شود.
//                     </p>
//                     <div className={style.link}>
//                         <span>
//                             <a href='/speeches'>مشاهده بيشتر</a>
//                         </span>
//                     </div>
//                 </div>
//             </div>
//             <div className={style.left}>  
//                 <div className={style.subproduct}>
//                     <div className={style.subcontent}> 
//                     <img className={style.subcover} src={lefttImage} alt='homespeeches'/>
//                     <div className={style.subplayicon}>
//                         <img src={playIcon} alt='homespeeches'/>
//                     </div>
//                 </div>
//                 <div className={style.text}> 
//                     <h3 className={style.subtitle}>فارسی صحبت کردن شهید   </h3>
//                     <p className={style.subpara}>سید حسن  (۱۳۳۹-۱۴۰۳ش) ملقب به سید مقاومت روحانی و سیاستمدار شیعه اهل لبنان، سومین دبیرکل   و از بنیانگذاران آن بود.
//                          در دوران دبیرکلی وی‌ (از سال ۱۹۹۲م-۲۰۲۴م) به قدرتی منطقه‌ای تبدیل شد. آزادسازی جنوب لبنان در ۲۰۰۰م از اشغال   آزادی اسیران
//                         لبنانی و بازپس‌گیری اجساد شهدای مقاومت از دست  در ۲۰۰۴م و پیروزی در جنگ ۳۳ روزه در ۲۰۰۶م در زمان دبیرکلی  روی داد. 
//                     </p>
//                     <div className={style.link}>
//                         <span>
//                             <a href='/speeches'>مشاهده بيشتر</a>
//                         </span>
//                     </div>
//                 </div>
//                 </div>
//                 <div className={style.subproduct}>
//                     <div className={style.subcontent}> 
//                     <img className={style.subcover} src={lefttImage2} alt='homespeeches'/>
//                     <div className={style.subplayicon}>
//                         <img src={playIcon} alt='homespeeches'/>
//                     </div>
//                 </div>
//                 <div className={style.text}> 
//                     <h3 className={style.subtitle}>فارسی صحبت کردن شهید سیدحسن نصرالله </h3>
//                     <p className={style.subpara}>سید حسن نَصْرالله (۱۳۳۹-۱۴۰۳ش) ملقب به سید مقاومت روحانی و سیاستمدار شیعه اهل لبنان، سومین دبیرکل حزب‌الله لبنان و از بنیانگذاران آن بود.
//                         حزب‌الله در دوران دبیرکلی وی‌ (از سال ۱۹۹۲م-۲۰۲۴م) به قدرتی منطقه‌ای تبدیل شد. آزادسازی جنوب لبنان در ۲۰۰۰م از اشغال رژیم صهیونیستی، آزادی اسیران
//                         لبنانی و بازپس‌گیری اجساد شهدای مقاومت از دست اسرائیل در ۲۰۰۴م و پیروزی در جنگ ۳۳ روزه در ۲۰۰۶م در زمان دبیرکلی نصرالله روی داد. او به دلیل مقاومت
//                     </p>
//                     <div className={style.link}>
//                         <span>
//                             <a href='/speeches'>مشاهده بيشتر</a>
//                         </span>
//                     </div>
//                 </div>
//                 </div>
//                 <div className={style.subproduct}>
//                     <div className={style.subcontent}> 
//                         <img className={style.subcover} src={lefttImage3} alt='homespeeches'/>
//                     <div className={style.subplayicon}>
//                         <img src={playIcon} alt='homespeeches'/>
//                     </div>
//                 </div>
//                 <div className={style.text}> 
//                     <h3 className={style.subtitle}>فارسی صحبت کردن شهید سیدحسن نصرالله </h3>
//                     <p className={style.subpara}>سید حسن نَصْرالله (۱۳۳۹-۱۴۰۳ش) ملقب به سید مقاومت روحانی و سیاستمدار شیعه اهل لبنان، سومین دبیرکل حزب‌الله لبنان و از بنیانگذاران آن بود.
//                         حزب‌الله در دوران دبیرکلی وی‌ (از سال ۱۹۹۲م-۲۰۲۴م) به قدرتی منطقه‌ای تبدیل شد. آزادسازی جنوب لبنان در ۲۰۰۰م از اشغال رژیم صهیونیستی، آزادی اسیران
//                         لبنانی و بازپس‌گیری اجساد شهدای مقاومت از دست اسرائیل در ۲۰۰۴م و پیروزی در جنگ ۳۳ روزه در ۲۰۰۶م در زمان دبیرکلی نصرالله روی داد. او به دلیل مقاومت
//                     </p>
//                     <div className={style.link}>
//                         <span>
//                             <a href='/speeches'>مشاهده بيشتر</a>
//                         </span>
//                     </div>
//                 </div>
//                 </div>
//             </div>
//         </div>
//     </div>
//     </>)
// }



import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import style from './Homespeeches.module.css';
// import playIcon from '../../Assets/products/602kss3h_expires_30_days.png';

export default function Homespeeches() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);



    // years
    const gregorianToPersianYear = (gregorianDate) => {
    const year = gregorianDate.getFullYear();
    const month = gregorianDate.getMonth() + 1; 
    const day = gregorianDate.getDate();
    
    if (month < 3 || (month === 3 && day < 21)) {
        return year - 622;
    }
    return year - 621;
};

const extractAndConvertYear = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
        return gregorianToPersianYear(date);
    }
    return '';
};

    // Strip limit text length
    const stripHtmlAndLimit = (html, maxLines = 4) => {
    if (!html) return '';
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    let text = tempDiv.textContent || tempDiv.innerText || '';
    
    // Remove extra whitespace
    text = text.replace(/\s+/g, ' ').trim();
    
    const charsPerLine = 100;
    const maxChars = maxLines * charsPerLine;
    
    return text.length > maxChars ? text.substring(0, maxChars) + '...' : text;
};

    useEffect(() => {
        axios.get('https://api.nasrollah.info/fa/?function=getLatestSpeeches')
            .then((response) => {
                setData(response.data);
                setLoading(false);
                // console.log(data)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
    return (
        <div className={style.stateBox}>
            <div className={style.loader}></div>
            <p className={style.stateText}>در حال بارگذاری...</p>
        </div>
    );
}

if (!data || data.length === 0) {
    return (
        <div className={style.stateBox}>
            <p className={style.stateText}>داده‌ای موجود نیست</p>
        </div>
    );
}

    const featuredSpeech = data[0];
    const otherSpeeches = data.slice(1, 4); 

    return (
        <>
            <div className={style.speeches}>
                <div className={style.container}>
                    {/* Right side - Featured speech */}
                    <div className={style.right}>
                        <Link 
                            to={`/speeches/${extractAndConvertYear(featuredSpeech.original_time_post)}/${featuredSpeech.slug_post}/${featuredSpeech.id_post}`}
                            className={style.content}
                        >
                            <img 
                                className={style.cover} 
                                src={featuredSpeech.featured_post} 
                                alt={featuredSpeech.title_post || 'سخنرانی'}
                                onError={(e) => {
                                    e.target.src = featuredSpeech.featured_image;
                                }}
                            />
                        </Link>
                        <div className={style.text}>
                            <h3>{featuredSpeech.title_post}</h3>
                            <p className={style.para}>
                                {stripHtmlAndLimit(featuredSpeech.html_post, 6)}
                            </p>
                            <div className={style.link}>
                                <span>
                                    <a href={`/speeches/${extractAndConvertYear(featuredSpeech.original_time_post)}`}>مشاهده بیشتر</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Left side - Other speeches */}
                    <div className={style.left}>
                        {otherSpeeches.map((speech, index) => (
                            <div key={speech.id_post || index} className={style.subproduct}>
                                <Link 
                                    to={`/speeches/${extractAndConvertYear(speech.original_time_post)}/${speech.slug_post}/${speech.id_post}`}
                                    className={style.subcontent}
                                >
                                    <img 
                                        className={style.subcover} 
                                        src={speech.featured_post} 
                                        alt={speech.title_post || 'سخنرانی'}
                                        onError={(e) => {
                                            e.target.src = speech.featured_image;
                                        }}
                                    />
                                </Link>
                                <div className={style.text}>
                                    <h3 className={style.subtitle}>{speech.title_post}</h3>
                                    <p className={style.subpara}>
                                        {stripHtmlAndLimit(speech.html_post, 3)}
                                    </p>
                                    <div className={style.link}>
                                        <span>
                                            <a href={`/speeches/${extractAndConvertYear(featuredSpeech.original_time_post)}`}>مشاهده بیشتر</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}